<template>
  <div>用户id:{{id}}的详情
    <el-input v-model.trim="value"></el-input>
  </div>
</template>
<script>
export default {
  name: "systemUserDetail",
  data() {
    return {
      value: "",
      id: ""
    }
  },
  created() {
    const {query} = this.$route
    this.id = query.id
  }
}
</script>
<style scoped lang="scss">

</style>